<template>
  <div class="app-hero__intro">
    <div class="logo">
      <span class="icon-linksift logo-desktop"></span>
    </div>

    <slot>
      <h1 class="heading heading--h6 text-center">
        Hello! LinkSift lets you explore what a website links to. Enter a url below to start sifting!
      </h1>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Intro',
};
</script>
